import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M17 7l-10 10","key":"svg-0"}],["path",{"d":"M8 7l9 0l0 9","key":"svg-1"}]]

const IconArrowUpRight = createReactComponent('outline', 'arrow-up-right', 'ArrowUpRight', __iconNode);

export default IconArrowUpRight;